import { createContext } from 'react';

const RadioGroupContext = createContext(null);

export { RadioGroupContext };
